<template>
  <div class="nav_top" v-if="!this.$route.query.hide">
    <!-- <sidebar class="sidebar-container" v-show="!hide"></sidebar> -->
    <div class="logo">
        <div class="g-logo-big"></div>
    </div>
    <div class="user item" slot="reference">
      <span>
        <img :src="img">
        <p class="user-name" style="height: 24px;">{{userName}}</p>
      </span>
    </div>
  </div>
</template>

<script>
import { getLoginName } from '@/api/totals.js'
import Sidebar from './Sidebar/index'

export default {
  name: 'erp_nav_top',
  components: {
    Sidebar
  },
  data () {
    return {
      input5: '',
      userName: '--',
      img: require('@/assets/defaultface.png'),
      balance: 0,
      myCredit: 0,
      messageList: [],
      unreadMessageCount: 0,
      authenticationType: null, // 实名认证类型
      authenticationStatus: null, // 实名认证状态
      informationStatus: null, // 完善资料状态
      ftInformationStatus: null, // 外贸完善资料状态
      allMenuDialog: false,
      searchProduct: '',
      allMenu: [],
      shortcutMenu: [],
      productWidth: 0,
      showMenu: 4,
      hide: false,
      popoverVisible: false
    }
  },
  watch: {
    $route (val) {
      this.select(val.path)
    }
  },
  computed: {
    routes () {
      return this.$router.options.routes
    }
  },
  mounted () {
    this.select(this.$route.path)
    this.getLoginName()
  },
  methods: {
    async getLoginName () {
      const { data } = await getLoginName()
      this.$store.dispatch('REQ_DEEP_TASK_LIST')
      this.userName = data
      this.$store.commit('set_ERPUSERNAME',data)
    },
    select (path) {
      const item = this.routes.find(e => {
        if (e.path === '/') { return }
        return '/' + path.split('/')[1] == e.path
      })
      this.$store.commit('SWITCHMENUBAR', item)
    }
  }
}
</script>

<style scoped lang="scss">

$mainColor: #001529;
.nav_top {
  height: 64px;
  // background: $mainColor;
  overflow: hidden;
}

.nav_top_right {
  float: right;
  height: 100%;
}

.nav_top_right div {
  float: left;
}
.g-logo-big {
    width: 215px;
    height: 70px;
    display: inline-block;
    background-repeat: no-repeat;
    background-image: url("~@/assets/menu/g-logo-big.png");
    // background-image: url("~@/assets/logo/zxk-logo3.png");
  }
.logo {
  float: left;
  height: 100%;
  display: flex;
  align-items: center;
  width: 215px;

  .mark {
    display: inline-block;
    margin-right: 12px;
    margin-top: 16px;
    width: 80px;
    text-align: center;
    height: 32px;
    line-height: 32px;
    border-radius: 3px;
    position: relative;
    background-color: #063b70;
    color: #fff;
    margin-left: 16px;
    cursor: pointer;
  }
}

.item {
  color: #fff;
  line-height: 64px;
  height: 50px;
  cursor: pointer;
  span {
    padding: 0 15px;
    height: 64px;
    display: inline-block;
    transition: all 0.6s;
    &:hover {
      color: #1890ff;
    }
  }
}
.x-badge {
  /deep/ sup {
    top: 15px;
    right: 20px;
    z-index: 10;
  }
}

.search {
  margin: 13px;
}

.user {
  cursor: pointer;
  float: right;
  > span {
    max-width: 195px;
    min-width: 120px;
  }

  &:hover {
    .user-name {
      color: #1890ff;
    }
  }
}

.user img {
  width: 24px;
  height: 24px;
  margin-top: 20px;
  margin-right: 8px;
  float: left;
  border-radius: 24px;
}

.user p {
  margin-top: 20px;
  color: #333;
  line-height: 24px;
  max-width: 60px;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  float: left;
}
@media screen and (max-width: 1200px) {
  .input-with-select {
    width: 190px !important;
  }
}
.product-wrap {
  float: left;
  color: #fff;

  li {
    float: left;
    line-height: 64px;
    padding: 0 12px;
    cursor: pointer;

    &:hover {
      a {
        color: #1890ff;
      }
    }
  }
  .x-icon-more {
    float: left;
    margin: 22px 0;
    padding: 0 10px;
  }
  span {
    float: left;
    cursor: pointer;
    height: 24px;
    line-height: 21px;

    .plus {
      margin-top: 22px;

      .el-icon-plus {
        border: 1px solid #fff;
        border-radius: 2px;
        height: 18px;
        width: 18px;
        text-align: center;
        margin-left: 12px;
        line-height: 17px;
      }

      i {
        font-size: 10px;
        font-weight: bold;
      }
    }
  }
}

.console-wrap {
  width: 1150px;
  // height: 560px;
  background-color: #00152a;
  padding: 20px 50px;

  .el-icon-close {
    float: right;
    font-size: 20px;
    margin-top: 20px;
    color: #999;
    cursor: pointer;
  }

  .search-product {
    width: 630px;

    /deep/ input {
      background: transparent;
      border-color: #aaa;
      color: #fff;
      height: 44px;
      line-height: 44px;
    }
    /deep/ .el-input__suffix {
      display: none;
    }
  }
  .fixed-num {
    color: #cccccc;
    font-size: 12px;
    margin-left: -16px;
  }
  .btn {
    border-top: 1px solid #333;
    padding: 15px 0;
    button {
      width: 140px;
    }
  }
}

.console-list {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  height: 560px;
  padding-top: 20px;
  .title-check {
    float: left;
    margin-right: 10px;
    margin-left: -26px;
  }

  > div {
    width: 175px;
    margin-right: 30px;
    margin-bottom: 20px;
    h5 {
      height: 40px;
      line-height: 40px;
      color: #999;
      border-bottom: 1px solid #333333;
      font-weight: normal;
      padding: 0 10px;

      img {
        float: left;
        width: 15px;
        margin-top: 12px;
        margin-right: 5px;
      }
    }

    p {
      height: 38px;
      line-height: 38px;
      padding: 0 5px;
      a {
        display: block;
      }
      &:hover {
        background-color: #08223d;

        a {
          color: #1890ff;
        }
      }

      .el-checkbox {
        margin-right: 5px;
      }

      a {
        color: #fff;
      }
    }
  }
}
.messages-icon {
  i {
    width: 16px;
    height: 16px;
    float: left;
    background: url("~@/assets/message-solid.png") no-repeat center;
    background-size: cover;
    margin-top: 24px;
  }
  &:hover {
    i {
      background-image: url("~@/assets/message-solid2.png");
    }
  }
}
.shopping-icon {
  i {
    width: 16px;
    height: 16px;
    display: inline-block;
    background: url("~@/assets/shopping.png") no-repeat center;
    background-size: cover;
    margin-top: 24px;
  }
  &:hover {
    i {
      background-image: url("~@/assets/shopping2.png");
    }
  }
}
.sidebar-container:hover {
  width: 225px !important;
}

.sidebar-container {
  margin-top: 64px;
  height: calc(100% - 64px);
  /deep/ .el-menu {
    border-right: none;
    .svg-icon {
      margin-left: 5px;
      margin-right: 25px;
    }
  }
}
</style>

<style lang="scss">
.bt-1 {
  border-top: 1px solid #666;
}

.el-badge__content {
  pointer-events: none;
}
.up[x-placement^="bottom"] {
  margin-top: 5px !important;
}
</style>
